import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios, { CancelToken } from "axios";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";
import {
  GetTeeSheetNotificationTemplate,
  TTeesheetNotificationTemplate,
} from "api/rpc/2024-04/facilityAdmin/teesheet/notification";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import MessageDisplay from "components/messageDisplay/MessageDisplay";

export default function TeeSheetNotificationTemplates() {
  const history = useHistory();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const [notificationTemplates, setNotificationTemplates] = useState<TTeesheetNotificationTemplate[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadNotificationTemplates(source.token);
    return () => source.cancel();
  }, []);

  async function loadNotificationTemplates(token?: CancelToken) {
    if (notificationTemplates !== undefined) {
      setNotificationTemplates(undefined);
    }

    const response = await GetTeeSheetNotificationTemplate({}, token ? false : true, token);

    if (token && token.reason) {
      return;
    }

    if (response.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading notification templates.")));
      setNotificationTemplates([]);
      return;
    }

    setNotificationTemplates(response.data as TTeesheetNotificationTemplate[]);
  }

  const primaryAction = {
    content: t("New Template"),
    action: () => history.push("/admin/settings/tee-sheet/notification-templates/new"),
  };

  return (
    <Page
      title={t("Notification Templates")}
      subtitle={t("Create a tee sheet notification template")}
      narrow
      primaryAction={primaryAction}
    >
      <DataTable columns={[{ label: t("Header") }, { label: t("Type") }]} loading={notificationTemplates === undefined}>
        {notificationTemplates?.length === 0 ? (
          <tr>
            <td colSpan={2}>
              <MessageDisplay
                icon={"circle-exclamation"}
                title={t("No Notification Templates Found")}
                content={t("Please create a notification template")}
              />
            </td>
          </tr>
        ) : (
          notificationTemplates?.map(notificationTemplate => (
            <tr
              key={notificationTemplate.id}
              className="clickable"
              onClick={() =>
                history.push(`/admin/settings/tee-sheet/notification-templates/${String(notificationTemplate.id)}`)
              }
            >
              <td>{notificationTemplate.subject}</td>
              <td>{notificationTemplate.user_type === "admin" ? t("Internal") : t("External")}</td>
            </tr>
          ))
        )}
      </DataTable>
    </Page>
  );
}
